//React
import React from "react";

import { withRouter } from "react-router";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myPostGoodUserAction from '../action/myPostGoodUserAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
//Add
//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
//Part
import PartUserName from './PartUserName';
import PartUserMainImg from './PartUserMainImg';
import PartPagingNextPrev from './PartPagingNextPrev';
//Icon
import CloseIcon from '@material-ui/icons/Close';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';

class Comp extends React.Component {



  _scroll(scrollpos) {
    let target = document.getElementById('my_post_good_user_list_block');
    if (target) {
      target.scrollTo(0, scrollpos);
    }
  }

  _clickProfile(pic) {
    let target = document.getElementById('my_post_good_user_list_block');
    if (target) {
      let scrollpos = target.scrollTop;
      this.props.myPostGoodUserScrollposSet(scrollpos);
      this.props.history.push('/partner/' + pic);
    }
  }

  _listGet(page) {
    this.props.myPostGoodUserListGet(this.props.my.postGoodUser.postId, page, () => {
      this._scroll(0);
    })
  }


  _renderList(value, index, arr) {
    return (
      <div key={index}>
        <div style={{padding:'3px'}}>
          {
            (this.props.my.profile.userdata_opposite_sex === value.userdata_sex) ? (
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'space-between',
                }}
              >
                <div style={{margin:'3px'}}>
                  <span
                    onClick={ () => this._clickProfile(value.userdata_id_code) }
                    style={{cursor:'pointer'}}
                  >
                    <PartUserMainImg
                      mainImg={value.userdata_mainImg}
                      width={'40px'}
                      height={'40px'}
                      radius={'50%'}
                    />
                  </span>
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:'0.8em', color:'#666'}}>
                    {value.date}
                  </div>
                  <span
                    onClick={ () => this._clickProfile(value.userdata_id_code) }
                    style={{cursor:'pointer'}}
                  >
                    <PartUserName
                      data={{
                        name: value.userdata_name,
                        sex: value.userdata_sex,
                        size: '1.2em',
                      }}
                    />
                  </span>
                  <div>
                    {value.userdata_age}才 {value.userdata_prof_region}
                  </div>
                </div>
                <div>
                  <div>
                    <IconButton
                      onClick={ () => this.props.partnerOperationOpen(value.userdata_id_code, ['refusal', 'breach', 'memo']) }
                    >
                      <MoreVertSharpIcon />
                    </IconButton>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'space-between',
                }}
              >
                <div style={{margin:'3px'}}>
                  <PartUserMainImg
                    mainImg={{
                      bool:true,
                      quit:false,
                      stop:false,
                      sex:value.userdata_sex,
                      src:null,

                    }}
                    width={'40px'}
                    height={'40px'}
                    radius={'50%'}
                  />
                </div>
                <div style={{flex:1}}>
                  <PartUserName
                    data={{
                      name: (value.userdata_sex === 'men') ? '男性のいいね': '女性のいいね',
                      sex: value.userdata_sex,
                      size: '1.2em',
                    }}
                  />

                  <div>
                    {value.count}件
                  </div>
                </div>
              </div>
            )
          }

        </div>
        {
          (arr.length - 1 > index) &&
          <Divider />
        }
      </div>
    )

  }

	render() {

		return (
      <Dialog
        open={(this.props.my.postGoodUser.datetime) ? true : false }
        onClose={ () => this.props.myPostGoodUserListInit() }
      >
        <div
          style={{
            width:'100%',
            minWidth:'240px',
          }}
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              textAlign:'center',
              alignItems:'center',
              justifyContent:'space-between',
              background:'#FFF',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              いいねを押した会員
            </div>
            <div>
              <IconButton onClick={ () => this.props.myPostGoodUserListInit() }>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>
        <div
          id='my_post_good_user_list_block'
          style={{
            overflowY:'auto',
            WebkitOverflowScrolling: 'touch',
          }}

        >
        {
          (this.props.my.postGoodUser.list.length > 0) ? (
            this.props.my.postGoodUser.list.map((value, index, arr) =>
              this._renderList(value, index, arr)
            )
          ): (
            <div style={{padding:'10px',color:'#666'}}>いいねはありませんでした</div>
          )
        }
        </div>
        <div style={{margin:'5px'}}>
          <PartPagingNextPrev
            page={this.props.my.postGoodUser.page}
            isNext={this.props.my.postGoodUser.isListNext}
            onClick={ (e) => this._listGet(e) }
          />
        </div>

      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myPostGoodUserAction,
    ...partnerOperationAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comp));
